module.exports = __webpack_public_path__ + "static/img/comment-success.6c309ccd.png";